import { apiGet, apiPatch, apiPost, apiPut, apiDelete } from './api';
import { 
    URL_LOGIN, URL_REGISTER, URL_LOGOUT, URL_ME, URL_REQUEST_RESET_PASSWORD, URL_SUBSCRIPTION,
    URL_RESET_PASSWORD, URL_CONFIRM_RESET_PASSWORD, URL_LOGIN_FROM_ADMIN_BACKOFFICE 
} from './urls';

export async function login({username, password}) {
	const response = await apiPost(URL_LOGIN, {username, password}, false);
	return response;
}

export async function register(payload) {
	const response = await apiPost(URL_REGISTER, payload, false);
	return response;
}

export async function loginFromAdminBackoffice(payload) {
	const response = await apiPost(URL_LOGIN_FROM_ADMIN_BACKOFFICE, payload, false);
	return response;
}

export async function logout(token) {
    const response = await apiPost(URL_LOGOUT, {token}, false);
    return response;
}

export async function getUser() {
	const response = await apiGet(URL_ME);
	return response;
}

export async function getSubscription(subscriptionId) {
    const response = await apiGet(URL_SUBSCRIPTION(subscriptionId));
	return response;
}


export async function requestResetPassword(email) {
    const response = await apiPost(URL_REQUEST_RESET_PASSWORD, {email}, false);
    return response;
}

export async function resetPassword(id, token) {
    const response = await apiGet(URL_RESET_PASSWORD(id, token), false);
    return response;
}

export async function confirmResetPassword(id, token, password, confirm_password) {
    const response = await apiPost(URL_CONFIRM_RESET_PASSWORD, {id, token, password, confirm_password}, false);
    return response;
}
